export * from './options-aside-category-change.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/reusable-components/options-admin-category-change-aside/index.ts